import React from 'react'
import PropTypes from 'prop-types'

// Models
import AnnouncementModel from 'models/Announcement'

// Api
import { downloadAttachFile } from 'api/announcement'

// Components
import Heading from 'ui/Heading'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import HTMLViewer from 'ui/HTMLViewer'
import FileItemAttachment from 'ui/FileItem/FileItemAttachment'

const Announcement = ({ announcement }) => {
  // Event
  const onDownloadAttachment = (fileName, setLoading) => {
    setLoading(true)
    downloadAttachFile(fileName).finally(() => {
      setLoading(false)
    })
  }

  return (
    <Row>
      <Col xs={12} sm={12} md={7} lg={7} xl={7}>
        <Heading size={28} paddingTop={5} paddingBottom={5}>
          {announcement.title}
        </Heading>

        <Text size={14} paddingBottom={15}>
          {announcement.publishedAt}
        </Text>

        <HTMLViewer data={announcement.content} />

        {announcement.files.length > 0 && (
          <>
            <Text color="#000000" paddingBottom={10}>
              Attachment:
            </Text>
            {announcement.files.map((name, index) => {
              return (
                <FileItemAttachment
                  key={index}
                  name={name}
                  onClick={onDownloadAttachment}
                />
              )
            })}
          </>
        )}
      </Col>
    </Row>
  )
}

Announcement.propTypes = {
  announcement: PropTypes.instanceOf(AnnouncementModel),
}

Announcement.defaultProps = {
  announcement: new AnnouncementModel(),
}
export default Announcement
